import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CenterJustifiedContainer } from '../center-justified-container';
import { MobileVerticallyPaddedContainer } from './mobile-vertically-padded-container';

const EnterpriseContact = () => (
  <CenterJustifiedContainer>
    <MobileVerticallyPaddedContainer>
      <FormattedMessage
        id="enterpriseContact"
        defaultMessage="Talk to our sales team about pricing for Cloud Enterprise"
      />
    </MobileVerticallyPaddedContainer>
  </CenterJustifiedContainer>
);

export { EnterpriseContact };
